var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"highlight--stats"},[_c('span',{staticClass:"stats--title mb-2"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"value--unit"},[_c('span',{staticClass:"stats--value"},[_vm._v(_vm._s(_vm.numberWithCommas(_vm.value)))]),_c('span',{staticClass:"stats--unit"},[_vm._v(_vm._s(_vm.unit))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }